import Autocomplete from '@/common/components/Inputs/Autocomplete/Autocomplete';

export default Autocomplete;
